import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import TokenComponent from "./TokenComponent";
import { Token } from "../types/Problem";

const ExerciseAnswer = ({
	tokens,
	pad,
	index,
	selectedAnswer,
	setSelectedAnswer,
	gotAnswer,
	isCorrectAnswer,
}: {
	tokens: Array<Token>;
	pad: string;
	index: number;
	selectedAnswer: number | null;
	setSelectedAnswer: React.Dispatch<React.SetStateAction<number | null>>;
	gotAnswer: boolean;
	isCorrectAnswer: boolean;
}) => {
	return (
		<TouchableOpacity
			className={`w-full py-4 justify-center items-center rounded-lg flex-row flex-wrap ${
				index === selectedAnswer
					? gotAnswer
						? isCorrectAnswer
							? "bg-[#c3e88d]"
							: "bg-[#ff5370]"
						: "bg-[#ffcb6b]"
					: "bg-[#1E272C]"
			} ${pad}`}
			onPress={() =>
				selectedAnswer !== index
					? setSelectedAnswer(index)
					: setSelectedAnswer(null)
			}
			disabled={gotAnswer}
		>
			{tokens.map((token, index) => {
				return <TokenComponent key={index} token={token} />;
			})}
		</TouchableOpacity>
	);
};

export default ExerciseAnswer;
